/**
 * Slice C.1 · NavigateChoice.
 * Direct fulfilment before optional navigation.
 * The bar never navigates automatically; a confirm-tap is required.
 */
export function NavigateChoice({ presentation, onConfirmNavigate, onDismiss }) {
  const target = presentation.primaryAction?.target || null;

  return (
    <div data-testid="ui-response-navigate-choice" className="space-y-3">
      <p className="text-[14px] leading-relaxed text-zinc-100">
        {presentation.narration}
      </p>
      <div className="flex gap-2 pt-1">
        <button
          type="button"
          data-testid="ui-navigate-to-confirm"
          disabled={!target}
          onClick={() => target && onConfirmNavigate?.(target)}
          className="inline-flex flex-1 items-center justify-center rounded-full bg-white text-zinc-900 px-4 py-2 text-[13px] font-semibold disabled:opacity-40"
        >
          {presentation.primaryAction?.label || "Take me there"}
        </button>
        <button
          type="button"
          data-testid="ui-navigate-to-dismiss"
          onClick={() => onDismiss?.()}
          className="inline-flex items-center justify-center rounded-full border border-white/20 text-white px-4 py-2 text-[13px]"
        >
          {presentation.secondaryAction?.label || "Not now"}
        </button>
      </div>
    </div>
  );
}

export default NavigateChoice;
